module.exports = __webpack_public_path__ + "img/rongYu12.24d5e074.png";